import { QueryModelTypeArgs } from '../generated';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { clientVersion } from '@trello/config';

export const modelTypeResolver = async (
  _parent: unknown,
  args: QueryModelTypeArgs,
  _context: unknown,
  info: QueryInfo,
) => {
  const apiUrl = `/1/types/${args.idOrName}`;
  const response = await fetch(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    credentials: 'include',
  });
  const types = await response.json();

  return prepareDataForApolloCache(types, info);
};
